import React, { createContext, useContext, useMemo, useState } from 'react';

type TabletopHeaderActionsContextValue = {
  actions: React.ReactNode;
  setActions: (actions: React.ReactNode) => void;
};

const TabletopHeaderActionsContext = createContext<TabletopHeaderActionsContextValue | null>(null);

export const TabletopHeaderActionsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [actions, setActions] = useState<React.ReactNode>(null);
  const value = useMemo(() => ({ actions, setActions }), [actions]);

  return (
    <TabletopHeaderActionsContext.Provider value={value}>
      {children}
    </TabletopHeaderActionsContext.Provider>
  );
};

export function useTabletopHeaderActions(): TabletopHeaderActionsContextValue {
  const context = useContext(TabletopHeaderActionsContext);
  if (!context) {
    throw new Error('useTabletopHeaderActions must be used within TabletopHeaderActionsProvider');
  }
  return context;
}

export const TabletopHeaderActionsSlot: React.FC<{ fallback?: React.ReactNode; className?: string }> = ({
  fallback = null,
  className = "shrink-0 flex items-center gap-2 flex-wrap justify-end",
}) => {
  const { actions } = useTabletopHeaderActions();
  if (!actions) return <>{fallback}</>;

  return (
    <div className={className}>
      {actions}
    </div>
  );
};
